// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReadonlyImageComponent_wrapper__3qLqn","image":"ReadonlyImageComponent_image__nLmPN"};